export default {
  getCookie(name) {
    let value = '; ' + document.cookie
    let parts = value.split('; ' + name + '=')
    if (parts.length === 2)
      return parts
        .pop()
        .split(';')
        .shift()
  },
  setCookie(name, data, expires = 'Fri, 31 Dec 9999 23:59:59 GMT', path = '/') {
    const value = encodeURIComponent(JSON.stringify(data))
    document.cookie = `${name}=${value}; expires=${expires}; path=${path}`
  },
  removeCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
  },
}
